import { Paperclip } from '@phosphor-icons/react';
import { getCategoryIcon } from '../UI/Icons';
import { getEventCategoryBgLight } from '../../utils/categories';

/**
 * EventPill - Displays an event in the calendar grid
 * Supports compact (month view) and expanded (mobile week view) modes
 */
export default function EventPill({ event, displayTime, compact = true }) {
  const categoryStyle = getEventCategoryBgLight(event.category);
  const hasAttachments = event.attachment_count > 0;
  
  // Different styling for start, middle, and end of multi-day events
  let roundedClass = 'rounded-sm';
  if (compact) {
    if (event.isStart && !event.isEnd) roundedClass = 'rounded-l-sm rounded-r-none';
    if (event.isEnd && !event.isStart) roundedClass = 'rounded-r-sm rounded-l-none';
    if (event.isMiddle) roundedClass = 'rounded-none';
  }

  // Build display text
  let displayText = '';
  
  if (event.isMiddle) {
    displayText = event.title;
  } else {
    displayText = displayTime ? `${displayTime} ${event.title}` : event.title;
  }

  if (compact) {
    return (
      <div
        className={`text-xs px-1.5 py-0.5 truncate cursor-pointer transition-all hover:opacity-80 ${roundedClass}`}
        style={{
          ...categoryStyle,
          border: `1px solid ${categoryStyle.color}33`,
        }}
      >
        <span className="flex items-center gap-1">
          {getCategoryIcon(event.category, { size: 12, className: 'flex-shrink-0' })}
          <span className="truncate">{displayText}</span>
          {hasAttachments && (
            <Paperclip size={10} className="flex-shrink-0 opacity-60" />
          )}
        </span>
      </div>
    );
  }

  // Expanded view for mobile
  return (
    <div
      className="p-2 rounded-sm"
      style={{
        ...categoryStyle,
        border: `1px solid ${categoryStyle.color}33`,
      }}
    >
      <div className="flex items-start gap-2">
        <div className="flex-shrink-0 mt-0.5">
          {getCategoryIcon(event.category, { size: 16 })}
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-medium text-sm truncate flex items-center gap-1">
            {event.title}
            {hasAttachments && (
              <Paperclip size={12} className="flex-shrink-0 opacity-60" />
            )}
          </div>
          {displayTime && (
            <div className="text-xs opacity-75">{displayTime}</div>
          )}
          {event.location && (
            <div className="text-xs opacity-60 truncate mt-0.5">{event.location}</div>
          )}
        </div>
      </div>
    </div>
  );
}
